import { render, staticRenderFns } from "./OrderInvoices.vue?vue&type=template&id=3e4af1ef"
import script from "./OrderInvoices.vue?vue&type=script&lang=js"
export * from "./OrderInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports